import { plural } from '@cian/utils';
import { getPriceText } from '../../../../../../shared/utils/string/getPriceText';

export const getModalTitle = (platformsCount: number, price: number, abGroup: string | null) => {
  const platformsText = plural(platformsCount, ['сайте', 'сайтах', 'сайтах']);
  const baseText = `Продублируйте это объявление на ${platformsCount} ${platformsText} недвижимости`;

  if (price && abGroup === 'C') {
    return `${baseText} за ${getPriceText(price)} в месяц.`;
  }

  return `${baseText}. Это бесплатно.`;
};
